import { EnaioRemarkAction } from "./EnaioRemarkAction";

export class EnaioRemarkObject {
    objectId = 0;
    objectTypeId = -1;
    text: string;
    action: EnaioRemarkAction = EnaioRemarkAction.insert;
}
